<template>
  <div id="video-upload" class="full-height pa-1">
    <file-pond
      ref="filepond"
      v-bind="filepondOptions"
      @init="handleFilepondInit"
      @addfilestart="handleFilepondAddFileStart"
    ></file-pond>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import VideoTranscoderService from '../services/VideoTranscoderService';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
import EventBus from '@snippets/js/eventBus';
import axios from 'axios';
import FakeProgress from '../js/fake-progress.js';
import {
  lightenDarkenHex,
} from '@utilities';
const CancelToken = axios.CancelToken;

export default {
  name: 'video-upload',
  components: {
    FilePond
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    teacherId: {
      type: Number,
      required: true,
    },
    startingKey: {
      type: String,
      validator: sk => ['webcam', 'screen', 'upload'].includes(sk),
    },
    studentId: {
      type: Number,
      default: null,
    },
    bulbAttemptId: {
      type: Number,
      default: null,
    },
    questionId: {
      type: Number,
      default: null,
    },
    discussionId: {
      type: Number,
      default: null,
    },
    bulbId: {
      type: Number,
      default: null,
    },
    lessonId: {
      type: Number,
      default: null,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    maxSize: {
      type: String,
      default: '5000MB',
    },
    maxDuration: {
      type: Number,
      default: 3600,
    },
    showCloseButton: {
      type: [String, Boolean],
      default: true,
      validator: value => [true, false, 'left'].includes(value),
    },
    debug: {
      type: Boolean,
      default: false,
    },
    hostingLog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ...mapState('videoTranscoder', [
        'generateRandomNumber'
      ]),
      processing: false,
      uploadInterval: null,
      assetInterval: null,
      source: null,
      canceled: false,
      uploadProgress: 0,
      fakeUploadProgress: null,
      uploadProgressInterval: null,
      assetProgress: 0,
      fakeAssetProgress: null,
      assetProgressInterval: null
    }
  },
	computed: {
    ...mapState('videoTranscoder', [
      'cardTab',
      'queryString',
      'loading',
      'keyboardFocus'
    ]),
    ...mapGetters('videoTranscoder', [
      'mobile'
    ]),
    filepondOptions() {
      return {
        maxFiles: 1,
        acceptedFileTypes: _.get(this, 'hostingLog.hasLimitedVideoUploadAccess')
          ? ['video/mp4']
          : [
            'video/*',
            'application/x-troff-msvideo',
            'video/quicktime',
            'video/x-flv',
            '.mp4',
            '.mov',
            '.avi',
            '.webm',
            '.wmv',
            '.mkv',
            '*.mp4',
            '*.mov',
            '*.avi',
            '*.webm',
            '*.wmv',
            '*.mkv',
            '*.flv'
          ],
        fileValidateTypeDetectType: async (source, type) => new Promise((resolve, reject) => {
          if (this.debug) console.log('SOURCE', source);
          if (this.debug) console.log('TYPE', type);
          let name = (source.name && typeof source.name === 'string') ? source.name.toLowerCase() : '';
          if (name.endsWith('.flv')) return resolve('video/x-flv');
          if (name.endsWith('.avi')) return resolve('video/avi');
          if (name.endsWith('.mkv')) return resolve('video/x-matroska');
          if (name.endsWith('.mov')) return resolve('video/quicktime');
          if (name.endsWith('.webm')) return resolve('video/webm');
          if (name.endsWith('.m4v')) return resolve('video/mp4');
          return resolve(type);
        }),
        labelIdle: this.mobile ? '<span class="filepond--label-action">Record a video (landscape only) or upload an existing one</span>' : '<span class="filepond--label-action" tabindex="-1">Browse your files</span>.',
        labelFileProcessing: 'Uploading',
        labelFileTypeNotAllowed: 'Invalid file type',
        fileValidateTypeLabelExpectedTypes: 'Expects a video file',
        allowRevert: false,
        maxFileSize: this.maxSize || '5000MB',
        maxFileDuration: this.maxDuration || 3600,
        server: {
          url: VideoTranscoderService.url,
          process: (fieldName, file, metadata, load, error, progress, abort) => {
            this.initUploadProcess();
            const formData = new FormData();
            formData.append('file', file, file.name);
            this.processing = true;
            const cancel = () => {
              return new Promise((resolve, reject) => {
                abort();
                this.processing = false;
                this.source.cancel();
                this.stopUploadProgress();
                this.stopAssetProgress();
                clearInterval(this.uploadInterval);
                clearInterval(this.assetInterval);
                if (this.$refs.filepond) this.$refs.filepond.removeFiles();
                return resolve();
              });
            }
            this.updateLoadingByIndex([
              {
                index: 0,
                cancel
              },
              {
                index: 1,
                cancel
              },
              {
                index: 2,
                cancel
              },
            ]);
            if (this.canceled) return cancel();
            VideoTranscoderService.transcodeVideo({
              formData,
              cancelToken: this.source.token,
              teacherId: this.teacherId,
              studentId: this.studentId,
              onUploadProgress: event => {
                let obj = {
                  index: 0,
                  progress: parseFloat(((event.loaded / event.total) * 100).toFixed(1)),
                }
                if (event.loaded === event.total) obj.status = 'success';
                this.updateLoadingByIndex(obj);
              }
            })
            .then(({data: upload}) => {
              if (this.canceled) return cancel();
              this.startUploadProgress(file.size);
              if (this.$el.querySelector('.filepond--file-status-main')) {
                this.$el.querySelector('.filepond--file-status-main').textContent = 'Processing';
              }
              return this.pollMuxUpload({
                muxUploadId: upload.id,
                cancelToken: this.source.token,
                teacherId: this.teacherId
              }, upload => {
                return _.has(upload, 'status') && upload.status === 'asset_created';
              });
            })
            .then(upload => {
              this.stopUploadProgress();
              if (this.canceled) return cancel();
              this.startAssetProgress(file.size);
              if (this.$el.querySelector('.filepond--file-status-main')) {
                this.$el.querySelector('.filepond--file-status-main').textContent = 'Transcoding';
              }
              return this.pollMuxAsset({
                muxAssetId: upload.assetId,
                cancelToken: this.source.token,
                teacherId: this.teacherId
              }, video => {
                return _.has(video, 'status') && video.status === 'ready';
              });
            })
            .then(muxVideo => {
              this.stopAssetProgress();
              this.updateLoadingByIndex({
                index: 2,
                progress: 100,
                status: 'success'
              });
              muxVideo.name = file.name.split('.')[0];
              load(muxVideo);
              this.processing = false;
              this.handleUploadSuccess(muxVideo);
            })
            .catch(err => {
              this.processing = false;
              if (axios.isCancel(err)) return;
              this.handleUploadError(err);
              error();
              this.stopUploadProgress();
              this.stopAssetProgress();
              clearInterval(this.uploadInterval);
              clearInterval(this.assetInterval);
            });
            return {
              abort: (e) => {
                this.processing = false;
                this.source.cancel();
                this.stopUploadProgress();
                this.stopAssetProgress();
                clearInterval(this.uploadInterval);
                clearInterval(this.assetInterval);
                abort();
              }
            };
          }
        }
      }
    }
	},
	methods: {
    ...mapMutations('videoTranscoder', [
      'toggleLoading',
      'updateLoadingByIndex'
    ]),
    startUploadProgress(bytes) {
      let percentage = (bytes / 104857600);
      let percentageSeconds = (percentage * 200) * 100;
      this.fakeUploadProgress = new FakeProgress({
        timeConstant: percentageSeconds,
        autoStart: true
      });
      this.initUploadRangeInterval();
    },
    stopUploadProgress() {
      if (this.fakeUploadProgress) this.fakeUploadProgress.end();
      clearInterval(this.uploadProgressInterval);
    },
    initUploadRangeInterval(min = 1000, max = 3000) {
      clearInterval(this.uploadProgressInterval);
      let random = this.generateRandomNumber(min, max);
      this.uploadProgressInterval = setTimeout(() => {
        this.updateLoadingByIndex([
          {
            index: 1,
            progress: parseFloat((this.fakeUploadProgress.progress * 100).toFixed(1))
          }
        ])
        this.initUploadRangeInterval(min, max);
      }, random);
    },
    startAssetProgress(bytes) {
      let percentage = (bytes / 104857600);
      let percentageSeconds = (percentage * 350) * 100;
      this.fakeAssetProgress = new FakeProgress({
        timeConstant: percentageSeconds,
        autoStart: true
      });
      this.initAssetRangeInterval();
    },
    stopAssetProgress() {
      if (this.fakeAssetProgress) this.fakeAssetProgress.end();
      clearInterval(this.assetProgressInterval);
    },
    initAssetRangeInterval(min = 1000, max = 3000) {
      clearInterval(this.assetProgressInterval);
      let random = this.generateRandomNumber(min, max);
      this.assetProgressInterval = setTimeout(() => {
        this.updateLoadingByIndex([
          {
            index: 2,
            progress: parseFloat((this.fakeAssetProgress.progress * 100).toFixed(1))
          }
        ])
        this.initAssetRangeInterval(min, max);
      }, random);
    },
    pollMuxUpload(pollData, validator) {
      if (this.canceled) {
        clearTimeout(this.uploadProgressTimeout);
        return clearInterval(this.uploadInterval);
      }
      this.updateLoadingByIndex([
        {
          index: 0,
          progress: 100,
          status: 'success'
        },
        {
          index: 1,
          status: true
        }
      ]);
      return new Promise((resolve, reject) => {
        return VideoTranscoderService.pollMuxUpload(pollData)
          .then(({data}) => {
            if (validator(data)) {
              return resolve(data);
            } else {
              this.uploadInterval = setInterval(() => {
                if (this.canceled) {
                  clearTimeout(this.uploadProgressTimeout);
                  return clearInterval(this.uploadInterval);
                }
                return VideoTranscoderService.pollMuxUpload(pollData)
                .then(({data}) => {
                  if (validator(data)) {
                    clearInterval(this.uploadInterval);
                    clearTimeout(this.uploadProgressTimeout);
                    this.updateLoadingByIndex({
                      index: 1,
                      progress: 100
                    });
                    setTimeout(() => {
                      return resolve(data);
                    }, 500);
                  }
                })
                .catch(error => {
                  clearInterval(this.uploadInterval);
                  clearTimeout(this.uploadProgressTimeout);
                  return reject(error);
                });
              }, 5000);
            }
          })
          .catch(error => {
            clearInterval(this.uploadInterval);
            clearTimeout(this.uploadProgressTimeout);
            reject(error);
          });
      });
    },
    pollMuxAsset(pollData, validator) {
      if (this.canceled) {
        clearTimeout(this.assetProgressTimeout);
        return clearInterval(this.assetInterval);
      }
      this.updateLoadingByIndex([
        {
          index: 1,
          progress: 100,
          status: 'success'
        },
        {
          index: 2,
          status: true
        }
      ]);
      return new Promise((resolve, reject) => {
        return VideoTranscoderService.pollMuxAsset(pollData)
          .then(({data}) => {
            if (validator(data)) {
              return resolve(data);
            } else {
              this.assetInterval = setInterval(() => {
                if (this.canceled) {
                  clearTimeout(this.assetProgressTimeout);
                  return clearInterval(this.assetInterval);
                }
                return VideoTranscoderService.pollMuxAsset(pollData)
                .then(({data}) => {
                  if (validator(data)) {
                    clearInterval(this.assetInterval);
                    clearTimeout(this.assetProgressTimeout);
                    this.updateLoadingByIndex({
                      index: 2,
                      progress: 100
                    });
                    setTimeout(() => {
                      return resolve(data);
                    }, 500);
                  }
                })
                .catch(error => {
                  clearInterval(this.assetInterval);
                  clearTimeout(this.assetProgressTimeout);
                  reject(error);
                });
              }, 10000);
            }
          })
          .catch(error => {
            clearInterval(this.assetInterval);
            clearTimeout(this.assetProgressTimeout);
            reject(error);
          });
      });
    },
    handleUploadSuccess(data) {
      this.$emit('success', data);
      if (this.debug) console.log('Final data', data);
      setTimeout(() => {
        if (_.get(this, '$refs.filepond.removeFiles')) this.$refs.filepond.removeFiles();
      }, 1500);
    },
    handleUploadError(error) {
      this.updateLoadingByIndex({
        index: this.loading.activeIndex(),
        status: 'error',
        error: error.msg || error.message || 'Unable to upload video at this time.'
      });
      this.$emit('error', error);
    },
    handleFilepondInit() {
      this.$nextTick(() => {
        let action = this.$el.querySelector('span.filepond--label-action');
        let input = this.$el.querySelector('input.filepond--browser');
        if (action) action.tabIndex = -1;
        if (input && this.keyboardFocus) input.focus();
      });
    },
    handleFilepondAddFileStart(file) {
      if (this.debug) console.log('Added file!', file);
      if (this.debug) console.log('file.fileSize', file.fileSize);
      if (this.debug) console.log('file.fileType', file.fileType);
      if (this.debug) console.log('file.fileExtension', file.fileExtension);
      if (this.debug) console.log('file.source', file.source);
      if (this.$el.querySelector('.filepond--file-status-main')) {
        this.$el.querySelector('.filepond--file-status-main').textContent = 'Initializing';
      }
    },
    initUploadProcess() {
      if (this.$el.querySelector('.filepond--file-status-main')) {
        this.$el.querySelector('.filepond--file-status-main').textContent = 'Uploading';
      }
      this.canceled = false;
      this.source = CancelToken.source();
      this.toggleLoading([
        {
          title: 'Uploading',
          success: 'Uploaded',
          color: lightenDarkenHex(this.$vuetify.theme.primary, 0.2, 20)
        },
        {
          title: 'Processing',
          success: 'Processed',
          color: this.$vuetify.theme.primary
        },
        {
          title: 'Transcoding',
          success: 'Transcoded',
          color: lightenDarkenHex(this.$vuetify.theme.primary, -0.2)
        }
      ]);
    },
    initEvents() {
      EventBus.$on('verify-exit-permissions', cb => {
        if (this.cardTab !== 1) return;
        cb(!this.processing);
      });
      EventBus.$on('cancel-transcode', () => {
        if (this.$refs.filepond) this.$refs.filepond.removeFiles();
        this.canceled = true;
      });
    }
  },
  watch: {
    cardTab(n) {
      if (n === 1) {
        let input = this.$el.querySelector('input.filepond--browser');
        if (input && this.keyboardFocus) input.focus();
      }
    }
  },
  beforeDestroy() {
    if (this.source) this.source.cancel();
  },
  mounted() {
    this.initEvents();
  }
};
</script>


<style lang="scss">
  #video-upload {
    .filepond-infinite-loading svg {
      animation: spin 1s linear infinite;
    }
  }
</style>
